module.exports = __webpack_public_path__ + "img/cejuqiuji.85338439.png";